import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../../../Layout/Layout";
// import LineChart from "./Charts/LineChart";
// import AreaChart from "./Charts/AreaChart";
import OrdersColumnChart from "./../../Charts/OrdersColumnChart";
// import POColumnChart from "./Charts/POColumnChart";
// import BarChart from "./Charts/BarChart";
import PieChart from "./../../Charts/PieChartCustomerV2";
import DonutChart from "./../../Charts/DonutChartCustomerV2";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
// import ItemService from "../../services/supplier_appCommonService";
import customerItemService from "../../../../services/customer_appCommonService";
import LoaderSmall from "../../../../Components/LoaderSmall";

import {
  // formatNumberShort,
  formatToTwoDigits,
  getCurrentDate,
} from "../../../../common/Validations";
import DatePickerComponent from "./../../Charts/FilterComponent/DatePickerComponent";
// import SupplierConstants from "../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import HorizontalBarChart from "../../Charts/HorizontalBarChart";
import LogisticsConstants from "../../../../common/LogisticsConstants";
// import TreeMapChartDashboardChart from "../../Charts/TreeMapChartDashboardChart";

const CustomerV2Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM);
    } else if (page === "loadingAdvice") {
      navigate(CustomerConstants.CUSTOMER_V2_LOADING_ADVICE_LIST);
    } else if (page === "totalInvoiceCount") {
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST);
    } else if (page === "totalUserCount") {
      navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);
    } else if (page === "totalFuelCount") {
      navigate(LogisticsConstants.LOGISTICS_FUEL_ENTRY_LIST);
    } else if (page === "totalTripDeilverd") {
      navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST_ACK);
    } else if (page === "totalTripInTransit") {
      navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST_INT);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);

  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  const [totalLoadingAdviceCount, setTotalLoadingAdviceCount] = useState("");
  const [totalLoadingAdviceCountStatus, setTotalLoadingAdviceCountStatus] =
    useState(false);

  const [totalInvoiceCount, setTotalInvoiceCount] = useState("");
  const [totalInvoiceCountStatus, setTotalInvoiceCountStatus] = useState(false);

  const [totalfuelCount, setTotalfuelCount] = useState("");
  const [totalfuelCountStatus, setTotalfuelCountStatus] = useState(false);

  const [totalTripCount, setTotalTripCount] = useState("");
  const [totalTripCountStatus, setTotalTripCountStatus] = useState(false);

  const [totalTripIntCount, setTotalTripIntCount] = useState("");
  const [totalTripIntCountStatus, setTotalTripIntCountStatus] = useState(false);

  // const [confirmedDispatchCount, setConfirmedDispatchCount] = useState("");
  // const [confirmedDispatchStatus, setConfirmedDispatchStatus] = useState(false);

  // const [orderCompletedCount, setOrderCompletedCount] = useState("");
  // const [orderPendingCount, setPendingCount] = useState("");
  // const [orderCompletedStatus, setOrderCompletedStatus] = useState(false);

  const [totalOrderCount, setTotalOrderCount] = useState("");
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [loadingAdviceColChart, setLoadingAdviceColChart] = useState("");
  const [invoiceColChart, setInvoiceColChart] = useState("");

  // const [supplierStatusColChartStatus, setSupplierStatusColChartStatus] =
  //   useState(false);

  const [hideItem, setHideItem] = useState(false);

  const [supplierStatusLoading, setSupplierStatusLoading] = useState(false);
  const [loadingAdviceLoading, setLoadingAdviceLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  //For Pie chart and Donut Chart
  const [salesTeamData, setSalesTeamData] = useState(null);
  const [marketingTeamData, setMarketingTeamData] = useState(null);
  const [salesTeamLoading, setSalesTeamLoading] = useState(false);
  const [marketingTeamLoading, setMarketingTeamLoading] = useState(false);

  const loadSalesTeamChart = async (filterData) => {
    setSalesTeamLoading(true);

    try {
      let queryName = "";
      if (filterData.action === "Yearly") {
        queryName = "Yearly_Pie_Sales_Order_Chart";
      } else if (filterData.action === "Monthly") {
        queryName = "Monthly_Pie_Sales_Order_Chart";
      } else if (filterData.action === "Custom") {
        queryName = "Custom_Pie_Sales_Order_Chart";
      }

      const payload = {
        module: "order",
        action: filterData.action, // "Yearly" | "Monthly" | "Custom"
        chartType: "pie",
        queryName,
        year: filterData.year,
        fromDate: filterData.fromDate,
        toDate: filterData.toDate,
        month: filterData.month,
        timeZone: "Asia/Calcutta",
      };

      // Call Api
      const response = await customerItemService.dashboard(payload);

      if (response?.status !== 200 || !response?.data) {
        throw new Error(response?.message || "Failed to load dashboard data");
      }

      const { categories, series, percentage } = response.data;

      setSalesTeamData({
        categories,
        series,
        percentage,
      });
    } catch (err) {
      console.error("loadSalesTeamChartNew error:", err);
      toast.error("Error loading Sales Team chart");
    } finally {
      setSalesTeamLoading(false);
    }
  };

  const loadMarketingTeamChart = async (filterData) => {
    setMarketingTeamLoading(true);

    try {
      let queryName = "";
      if (filterData.action === "Yearly") {
        queryName = "Yearly_Pie_Order_Chart";
      } else if (filterData.action === "Monthly") {
        queryName = "Monthly_Pie_Order_Chart";
      } else if (filterData.action === "Custom") {
        queryName = "Custom_Pie_Order_Chart";
      }

      const payload = {
        module: "order",
        action: filterData.action,
        chartType: "doughnut",
        queryName,
        year: filterData.year,
        month: filterData.month,
        fromDate: filterData.fromDate,
        toDate: filterData.toDate,
        timeZone: "Asia/Calcutta",
      };

      //Call dashboard API
      const response = await customerItemService.dashboard(payload);

      if (response?.status !== 200 || !response?.data) {
        throw new Error(response?.message || "Failed to load marketing chart");
      }

      const { categories, series, percentage, getQueryResponse } =
        response.data;

      const chartData = {
        categories,
        series,
        percentage,
        rows: getQueryResponse,
      };

      setMarketingTeamData(chartData);
    } catch (error) {
      console.error("Error loading Marketing Team chart:", error);
      toast.error("Error loading Marketing Team chart");
    } finally {
      setMarketingTeamLoading(false);
    }
  };

  const hasChartData = (data) => {
    if (!data) return false;
    if (!Array.isArray(data.series)) return false;
    return data.series.some((v) => v > 0);
  };

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    let obj = {
      queryName: "totalOrderBookingCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalOrderCount(item.data);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  // loadOrderCompletedCount
  // const loadOrderCompletedCount = async (totalOrderCountVal) => {
  //   setOrderCompletedStatus(true);
  //   let obj = {
  //     queryName: "totalOrderCompletedCount",
  //   };

  //   await customerItemService.ChartCountCard(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setOrderCompletedCount(item.data);
  //       let orderComplete = item.data;
  //       setPendingCount(totalOrderCountVal - orderComplete);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setOrderCompletedStatus(false);
  // };

  // loadConfirmedDispatchCount
  // const loadConfirmedDispatchCount = async () => {
  //   setConfirmedDispatchStatus(true);
  //   let obj = {
  //     queryName: "totalOrderBookingCount",
  //   };

  //   await customerItemService.ChartCountCard(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setConfirmedDispatchCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setConfirmedDispatchStatus(false);
  // };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      queryName: "totalCustomerCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalUserCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  // loadInvoice
  const loadInvoiceCount = async () => {
    setTotalInvoiceCountStatus(true);
    let obj = {
      queryName: "Company_And_Customer_Ledger",
      rowFilter: {
        $and: [
          {
            transactionType: "INV",
          },
        ],
      },
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateCustomerQuery(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalInvoiceCount(item?.total ?? 0);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    // let obj = {
    //   queryName: "totalInvoiceCount",
    // };

    // await customerItemService.ChartCountCard(obj).then((item) => {
    //   // console.log(">> Details res!", item);
    //   if (item?.status === 200) {
    //     setTotalInvoiceCount(item.data);
    //   } else {
    //     toast.error(item?.message || "Please try again for Total User Count", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //   }
    // });
    setTotalInvoiceCountStatus(false);
  };

  // loadFuel
  const loadFuelCount = async () => {
    setTotalfuelCountStatus(true);
    let obj = {
      queryName: "totalLogisticsFuelCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalfuelCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalfuelCountStatus(false);
  };

  // loadtripDeliverd
  const loadTripCount = async () => {
    setTotalTripCountStatus(true);
    let obj = {
      queryName: "totalLogisticsTripCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalTripCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalTripCountStatus(false);
  };

  // loadFuel
  const loadTripIntCount = async () => {
    setTotalTripIntCountStatus(true);
    let obj = {
      queryName: "totalLogisticsInTripCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalTripIntCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalTripIntCountStatus(false);
  };

  // loading Advice
  const loadingAdviceCount = async () => {
    setTotalLoadingAdviceCountStatus(true);
    let obj = {
      queryName: "totalLoadingAdviceCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalLoadingAdviceCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalLoadingAdviceCountStatus(false);
  };

  const suppliersChart = async (filterData) => {
    setSupplierStatusLoading(true);
    filterData.module = "order";
    filterData.chartType = "bar";

    try {
      const item = await customerItemService.dashboard(filterData);
      if (item?.status === 200) {
        item.data.module = "order";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Orders");
      }
    } catch (error) {
      toast.error("Error fetching Orders chart data");
    }
    setSupplierStatusLoading(false);
  };

  const loadingAdviceChart = async (filterData) => {
    setLoadingAdviceLoading(true);
    filterData.module = "loadingAdvice";
    filterData.chartType = "bar";

    try {
      const item = await customerItemService.dashboard(filterData);
      if (item?.status === 200) {
        item.data.module = "loadingAdvice";
        setLoadingAdviceColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Loading Advice");
      }
    } catch (error) {
      toast.error("Error fetching Loading Advice chart data");
    }
    setLoadingAdviceLoading(false);
  };

  const InvoiceChart = async (filterData) => {
    setInvoiceLoading(true);
    filterData.module = "invoice";
    filterData.chartType = "bar";

    const item = await customerItemService.dashboard(filterData);
    if (item?.status === 200) {
      setInvoiceColChart(item.data); // ✅ FIXED from serInvoiceColChart
    } else {
      toast.error(item?.message || "Please try again for Invoice Chart");
    }
    setInvoiceLoading(false);
  };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter);

    await suppliersChart(filter);
    await loadingAdviceChart(filter);
    await InvoiceChart(filter);
    await loadSalesTeamChart(filter);
    await loadMarketingTeamChart(filter);
    // await poChart(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadOrderCount();
    // loadOrderCompletedCount();
    // loadPostDispatchCount();
    // loadConfirmedDispatchCount();
    loadTripIntCount();
    loadTripCount();
    loadFuelCount();
    loadCustomerCount();
    loadInvoiceCount();
    loadingAdviceCount();

    suppliersChart(defaultFilter);
    loadingAdviceChart(defaultFilter);
    InvoiceChart(defaultFilter);
    //---------------------For Pie and Donut Chart------------------------------
    loadSalesTeamChart(defaultFilter);
    loadMarketingTeamChart(defaultFilter);
    // poChart(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // console.log(">> userRole", userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  //role selection
  const [userRoleData, serUserRoleData] = useState();
  useEffect(() => {
    if (userData?.roles) {
      const allowedRoles = ["SALES-OFFICER"];
      const isAllowed = userData.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      serUserRoleData(isAllowed);
    }
  }, [userData]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <div className="row">
                <div className="col-lg-3 commTopButtonRightLeftPadding">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Orders
                        {/* <span>| Today</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-boxes"></i>
                        </div>
                        <div className="ps-3">
                          <LoaderSmall isLoading={totalOrderCountStatus} />
                          <h6>
                            {!totalOrderCountStatus
                              ? formatToTwoDigits(totalOrderCount || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                          <span className="text-muted small pt-2 ps-1">
                            Total Count
                          </span>
                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("totalOrderCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {!hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card customers-card">
                      <div className="card-body">
                        <h5 className="card-title">Loading</h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-truck"></i>{" "}
                          </div>
                          <div className="ps-3">
                            <LoaderSmall
                              isLoading={totalLoadingAdviceCountStatus}
                            />
                            <h6>
                              {!totalLoadingAdviceCountStatus
                                ? formatToTwoDigits(
                                    totalLoadingAdviceCount || 0,
                                  )
                                : ""}
                            </h6>

                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("loadingAdvice")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card revenue-card">
                      <div className="card-body">
                        <h5 className="card-title">Invoice</h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-text"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalInvoiceCountStatus} />
                            <h6>
                              {!totalInvoiceCountStatus
                                ? formatToTwoDigits(totalInvoiceCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalInvoiceCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card customers-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Customers
                          {/* <span>| This Year</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalUserCountStatus} />
                            <h6>
                              {!totalUserCountStatus
                                ? formatToTwoDigits(totalUserCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalUserCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* fuel count */}
                {!userRoleData && !hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card revenue-card">
                      <div className="card-body">
                        <h5 className="card-title">Fuel</h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-fuel-pump"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalfuelCountStatus} />
                            <h6>
                              {!totalfuelCountStatus
                                ? formatToTwoDigits(totalfuelCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalFuelCount")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Trip count */}
                {!userRoleData && !hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card revenue-card">
                      <div className="card-body">
                        <h5 className="card-title">Trip (Delivered)</h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-truck"></i>{" "}
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalTripCountStatus} />
                            <h6>
                              {!totalTripCountStatus
                                ? formatToTwoDigits(totalTripCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalTripDeilverd")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!userRoleData && !hideItem && (
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card customers-card">
                      <div className="card-body">
                        <h5 className="card-title">Trip (In Transit)</h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-truck-front"></i>{" "}
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalTripIntCountStatus} />
                            <h6>
                              {!totalTripIntCountStatus
                                ? formatToTwoDigits(totalTripIntCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                            <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span>
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() =>
                                navigateToMainPage("totalTripInTransit")
                              }
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}
              <div className="row">
                {/* Orders */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Orders</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall isLoading={supplierStatusLoading} />
                      <h6>
                        {!supplierStatusLoading ? (
                          <OrdersColumnChart
                            key="order"
                            chartdata={supplierStatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
                {/* Loading Advice */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Loading</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall isLoading={loadingAdviceLoading} />
                      <h6>
                        {!loadingAdviceLoading ? (
                          <OrdersColumnChart
                            key="loadingAdvice"
                            chartdata={loadingAdviceColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
                {/* Invoice */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Invoice</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall isLoading={invoiceLoading} />
                      <h6>
                        {!invoiceLoading ? (
                          <OrdersColumnChart
                            key="invoice"
                            chartdata={invoiceColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                {/* PO */}
                {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Purchase Order</h5>
                      <LoaderSmall isLoading={poStatusColChartStatus} />
                      <h6>
                        {!poStatusColChartStatus ? (
                          <POColumnChart
                            key="po"
                            chartdata={poStatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div> */}

                {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Procurement</h5>

                      <div id="lineChart"></div>
                      <LineChart />
                    </div>
                  </div>
                </div> */}

                {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Revenue</h5>

                      <div id="areaChart"></div>
                      <AreaChart />
                    </div>
                  </div>
                </div> */}

                {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Country</h5>

                      <div id="barChart"></div>
                      <BarChart />
                    </div>
                  </div>
                </div> */}

                {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Sales Team</h5>

                      <div id="pieChart"></div>
                      <PieChart />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Marketing Team</h5>

                      <div id="donutChart"></div>
                      <DonutChart />
                    </div>
                  </div>
                </div> */}
                {/* Sales Team Order Pie Chart */}
                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Orders</h5>

                      <LoaderSmall isLoading={salesTeamLoading} />
                      {!salesTeamLoading ? (
                        hasChartData(salesTeamData) ? (
                          <PieChart
                            chartdata={salesTeamData}
                            tooltipSuffix="orders"
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No orders available
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* Marketing Team Customer Orders Doughnut Chart */}
                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Sales</h5>

                      <LoaderSmall isLoading={marketingTeamLoading} />

                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          <DonutChart
                            chartdata={marketingTeamData}
                            valueLabel="Total Sales"
                            tooltipSuffix="orders"
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No Sales available
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* Customer Orders Horizontal Bar Chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title mb-3">Orders by Customer</h5>
                      <LoaderSmall isLoading={marketingTeamLoading} />
                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          // <HorizontalBarChart
                          //   chartdata={marketingTeamData}
                          //   height="450px"
                          //   barColor="#008FFB" // Blue
                          //   xAxisTitle="Number of Orders"
                          //   tooltipUnit="orders"
                          //   decimalPoints={0} // No decimals for order counts
                          // />

                          <HorizontalBarChart
                            chartdata={marketingTeamData}
                            height="450px"
                            barColor="#008FFB"
                            xAxisTitle="Number of Orders"
                            tooltipUnit="orders"
                            decimalPoints={0}
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No orders available
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Customer Orders</h5>
                      <LoaderSmall isLoading={marketingTeamLoading} />
                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          <TreeMapChartDashboardChart
                            chartdata={marketingTeamData}
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No customer orders available
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                </div> */}
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CustomerV2Dashboard;
